/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';

/**
 * 
 * @export
 * @interface UserMigrationQueryRoleResponse
 */
export interface UserMigrationQueryRoleResponse {
    /**
     * 
     * @type {any}
     * @memberof UserMigrationQueryRoleResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryRoleResponse
     */
    roleName?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof UserMigrationQueryRoleResponse
     */
    requiredOrganizationGroupType?: OrganizationGroupType;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof UserMigrationQueryRoleResponse
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
}



/**
 * Check if a given object implements the UserMigrationQueryRoleResponse interface.
 */
export function instanceOfUserMigrationQueryRoleResponse(value: object): value is UserMigrationQueryRoleResponse {
    return true;
}

export function UserMigrationQueryRoleResponseFromJSON(json: any): UserMigrationQueryRoleResponse {
    return UserMigrationQueryRoleResponseFromJSONTyped(json, false);
}

export function UserMigrationQueryRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationQueryRoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'roleName': json['roleName'] === undefined ? undefined : json['roleName'] === null ? null : json['roleName'],
        'requiredOrganizationGroupType': json['requiredOrganizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['requiredOrganizationGroupType']),
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
    };
}

export function UserMigrationQueryRoleResponseToJSON(json: any): UserMigrationQueryRoleResponse {
    return UserMigrationQueryRoleResponseToJSONTyped(json, false);
}

export function UserMigrationQueryRoleResponseToJSONTyped(value?: UserMigrationQueryRoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'requiredOrganizationGroupType': OrganizationGroupTypeToJSON(value['requiredOrganizationGroupType']),
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
    };
}

